<template>
  <div class="container">
    <!-- <textarea name="txt" rows="15" id="txt" v-model="txt" placeholder="请输入内容"></textarea> -->
    <p>内容</p>
    <van-field
      v-model="txt"
      rows="4"
      autosize
      type="textarea"
      placeholder="请输入报告内容"
      show-word-limit
      maxlength="140"
      style="background: #f9f9f9; margin-top: 12px; border-radius: 2px"
    />
    <p style="padding-top: 10px">请选择上传类型</p>
    <van-radio-group
      v-model="radio"
      direction="horizontal"
      style="padding: 10px 0"
      @change="
        fileList = [];
        show = true;
      "
    >
      <van-radio name="1">图片</van-radio>
      <van-radio name="2">视频</van-radio>
    </van-radio-group>
    <div v-if="radio == 1">
      <van-uploader
        v-show="show"
        style="padding: 10px 0"
        :after-read="afterRead"
        multiple
        v-model="fileList"
        :max-count="maxcount"
        accept="image/*"
        :before-read="beforeRead"
      />
    </div>
    <div v-else-if="radio == 2">
      <van-uploader
        v-show="show"
        style="padding: 10px 0"
        :after-read="afterRead"
        multiple
        v-model="fileList"
        :max-count="maxcount"
        accept="video/*"
        :before-read="beforeRead"
      />
      <div class="video" v-show="!show" style="padding: 10px 0">
        <video
          style="width: 50vw; background: black"
          :src="video"
          controls
        ></video>
      </div>
    </div>
    <!-- <div class="flexdiv" style="width: 100%">
      <div class="flexdiv border" style="justify-content: unset">
        <i class="el-icon-location-outline"></i>
        <span class="title">{{ title }}</span>
      </div>
      <el-button type="warning" @click="submit">发布</el-button>
    </div> -->
    <div class="bt" @click="submit">发布</div>
  </div>
</template>
<script>
export default {
  name: "release",
  data() {
    return {
      txt: "",
      fileList: [],
      title: "",
      type: "",
      maxcount: 9,
      show: true,
      video: "",
      loading: false,
      radio: "1",
    };
  },
  created() {
    this.$axios({
      method: "post",
      url: "/api/task/detail",
      data: this.qs.stringify({
        id: this.$route.query.id,
      }),
    }).then((res) => {
      console.log(res.data);
      this.title = res.data.data.task.title;
    });
  },
  methods: {
    afterRead(file) {
      this.loading = true;
      console.log(file);
      console.log("length" + this.fileList.length);
      let filelength = this.fileList.length;
      if (file.file) {
        let formData = new FormData();
        formData.append("file", file.file);
        this.$axios
          .post("/api/common/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            console.log(res.data);
            console.log(this.fileList);
            if (res.data.code == 0) {
              this.fileList[this.fileList.length - 1].url = res.data.data.url;
              //如果上传的是视频
              if (this.type == "video") {
                this.video = this.fileList[0].url;
                this.show = false;
                this.$forceUpdate();
              }
            } else {
              this.$toast(res.data.msg);
            }
            this.loading = false;
          });
      } else {
        for (let i = 0; i < file.length; i++) {
          let formData = new FormData();
          formData.append("file", file[i].file);
          this.$axios
            .post("/api/common/upload", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
              console.log(res.data);
              console.log(this.fileList);
              if (res.data.code == 0) {
                console.log(filelength, i, file.length);
                this.fileList[this.fileList.length - (file.length - i)].url =
                  res.data.data.url;
              } else {
                this.$toast(res.data.msg);
              }
              this.loading = false;
            });
        }
      }
    },
    beforeRead(file) {
      //上传的数量大于1
      if (this.fileList.length == 0) {
        this.type = "";
        this.maxcount = 9;
      }
      if (file.length) {
        if (this.type == "") {
          if (file[0].type.indexOf("image") != -1) {
            this.maxcount = 9;
            this.type = "image";
          } else {
            this.type = "video";
            this.maxcount = 1;
            this.$toast("视频只能选择一个");
            return;
          }
        }
        for (let i in file) {
          if (file[i].type.indexOf("image") != -1) {
            if (this.type != "image") {
              this.$toast("视频与图片不能同时上传");
              return false;
            }
          } else {
            if (this.type != "video") {
              this.$toast("视频与图片不能同时上传");
              return false;
            }
          }
        }
      } else {
        let str = file.type;
        if (str.indexOf("image") != -1) {
          //是img
          this.maxcount = 9;
          if (this.type == "") {
            this.type = "image";
          }
          if (this.type == "video") {
            this.$toast("视频与图片不能同时上传");
            return false;
          }
        }
        if (str.indexOf("video") != -1) {
          this.maxcount = 1;
          if (this.type == "") {
            this.type = "video";
          }
          if (this.type == "image") {
            this.$toast("视频与图片不能同时上传");
            return false;
          }
        }
      }
      return true;
    },
    submit() {
      let imgs = [];
      let video = "";
      if (this.loading) {
        this.$toast("尚在上传中，请稍候");
        return;
      }
      if (this.fileList.length > 0) {
        for (let i in this.fileList) {
          if (this.fileList[i].url == "") {
            this.$toast("尚在上传中，请稍候");
            return;
          }
        }
      }
      if (this.fileList.length > 0 && this.type == "image") {
        for (let i in this.fileList) {
          imgs.push(this.fileList[i].url);
        }
        for (let i in imgs) {
          if (imgs[i] == "") {
            this.$toast("图片尚未上传完毕，请稍候");
            return;
          }
        }
      }
      if (this.fileList.length > 0 && this.type == "video") {
        video = this.fileList[0].url;
        if (video == "") {
          this.$toast("视频尚未上传完毕，请稍候");
          return;
        }
      }
      console.log(imgs);
      this.$axios({
        method: "post",
        url: "/api/task/report",
        data: this.qs.stringify({
          token: sessionStorage.getItem("wmtoken"),
          content: this.txt,
          imgs: imgs,
          video: video,
          id: this.$route.query.id,
        }),
      }).then((res) => {
        if (res.data.code == 0) {
          this.$toast("发布成功");
          this.$router.push("/");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  padding: 20px;
}
textarea {
  outline: transparent;
  border: none;
  width: 100%;
}
.flexdiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-button {
  background: #1646c0;
  border-color: transparent;
  padding: 10px 20px;
}
.border {
  border: 1px solid black;
  padding: 5px;
  border-radius: 30px;
  font-size: 14px;
  width: 50%;
}
.title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.bt {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  background: #1646c0;
  color: white;
  width: 343px;
  margin: 0 auto;
  text-align: center;
  line-height: 48px;
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/release.vue